export default __webpack_public_path__ + "static/m-process-05-3c1b97e023d081d8ea2607553491c407.svg";